module.exports = __webpack_public_path__ + "static/media/custom-ex-10.cf30cb5b.jpg";